import { request } from "../utils/request";

export interface CompanyModel {
  _id: string;
  name: string;
  website: string;
  description: string;
  matching_offerings: string[];
  match_reason: string;
  match_score: number;
  selected: boolean;
}

export const getCompanies = async (): Promise<CompanyModel[]> => {
    try {
        const response = await request('/company/list', {
            method: 'GET',
            credentials: 'include',
        });
        return response.items;
    } catch (error: any) {
        const detail = error?.data?.detail || error?.message || 'Not authenticated';
        throw new Error(detail);
    }
};